var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        [
          _c(
            "div",
            { staticClass: "single container-max page-content" },
            [
              _c("div", { staticClass: "row position-relative" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-7 mt-5" },
                  [_vm._t("image-carousel")],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-5 mt-md-5" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "stick-in-parent",
                          rawName: "v-stick-in-parent"
                        }
                      ]
                    },
                    [
                      _vm.currentVariation.filter.hasManufacturer
                        ? _c(
                            "div",
                            {
                              staticClass: "producertag h6 producer text-muted"
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.currentVariation.item.manufacturer
                                      .externalName
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "h1",
                        {
                          staticClass: "h2 title",
                          attrs: { "data-testing": "item-name" }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm._f("itemName")(_vm.currentVariation)
                                ) +
                                "\n              "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm._t("tag-list"),
                      _vm._v(" "),
                      _vm.isShortDescriptionActive &&
                      _vm.currentVariation.texts.shortDescription !== ""
                        ? _c("p", {
                            staticClass: "single-description",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.currentVariation.texts.shortDescription
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-5" }, [
                        _c(
                          "span",
                          { staticClass: "articlenumber small text-muted" },
                          [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.singleItemNumber"
                                  )
                                ) + " "
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.currentVariation.variation.number)
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.attributes.length || Object.keys(_vm.units).length
                        ? _c(
                            "div",
                            { staticClass: "mb-3" },
                            [_c("variation-select")],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentVariation.variation.bundleType === "bundle"
                        ? _c("item-bundle", {
                            attrs: {
                              "bundle-type":
                                _vm.currentVariation.variation.bundleType,
                              "bundle-components":
                                _vm.currentVariation.bundleComponents
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("before-price"),
                      _vm._v(" "),
                      _vm.currentVariation.filter.isSalable &&
                      _vm.variationGroupedProperties.length
                        ? _c("div", [_c("order-property-list")], 1)
                        : _vm._e(),
                      _vm._v(" "),
                      _c("graduated-prices"),
                      _vm._v(" "),
                      _c("item-price", {
                        attrs: {
                          "show-cross-price": _vm.isRecommendedPriceActive
                        }
                      }),
                      _vm._v(" "),
                      _vm._t("after-price"),
                      _vm._v(" "),
                      _c("item-availability"),
                      _vm._v(" "),
                      _c("div", { staticClass: "my-3" }, [
                        _c(
                          "div",
                          { staticClass: "w-100" },
                          [_vm._t("before-add-to-basket")],
                          2
                        ),
                        _vm._v(" "),
                        _vm.currentVariation.item.itemType === "set"
                          ? _c(
                              "div",
                              { staticClass: "alert alert-info w-100" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemSetInfo"
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          : _c("div", [
                              _c("div", {
                                ref: "buyboxCtaSentinel",
                                attrs: { "aria-hidden": "true" }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  ref: "buyboxCta",
                                  staticClass:
                                    "col-12 col-sm-7 col-md-12 col-lg-8 my-3"
                                },
                                [
                                  _c("add-to-basket", {
                                    attrs: {
                                      "variation-id":
                                        _vm.currentVariation.variation.id,
                                      "is-salable":
                                        !!_vm.currentVariation.filter &&
                                        _vm.currentVariation.filter.isSalable,
                                      "has-children":
                                        !!_vm.currentVariation.filter &&
                                        _vm.currentVariation.filter
                                          .hasActiveChildren,
                                      "interval-quantity":
                                        _vm.currentVariation.variation
                                          .intervalOrderQuantity || 1,
                                      "minimum-quantity":
                                        _vm.currentVariation.variation
                                          .minimumOrderQuantity,
                                      "maximum-quantity":
                                        !!_vm.currentVariation.variation
                                          .maximumOrderQuantity &&
                                        _vm.currentVariation.variation
                                          .maximumOrderQuantity > 0
                                          ? _vm.currentVariation.variation
                                              .maximumOrderQuantity
                                          : null,
                                      "order-properties": _vm.currentVariation.properties.filter(
                                        function(prop) {
                                          return prop.property.isOderProperty
                                        }
                                      ),
                                      "has-order-properties":
                                        _vm.currentVariation.hasOrderProperties,
                                      "has-required-order-property":
                                        _vm.currentVariation
                                          .hasRequiredOrderProperty,
                                      "use-large-scale": false,
                                      "show-quantity": true,
                                      "item-url": _vm._f("itemURL")(
                                        _vm.currentVariation
                                      ),
                                      "is-variation-selected":
                                        _vm.isVariationSelected &&
                                        _vm.currentVariation.filter.isSalable,
                                      "has-price": _vm._f(
                                        "hasItemDefaultPrice"
                                      )(_vm.currentVariation)
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "w-100" },
                          [_vm._t("after-add-to-basket")],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _vm.isWishListEnabled
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c("add-to-wish-list", {
                                  attrs: {
                                    "variation-id":
                                      _vm.currentVariation.variation.id
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("additional-content-after-add-to-basket"),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "vat small text-muted" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.singleItemFootnote1"
                                )
                              ) +
                              "\n              "
                          ),
                          _vm.showNetPrices
                            ? [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemExclVAT"
                                    )
                                  )
                                )
                              ]
                            : [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemInclVAT"
                                    )
                                  )
                                )
                              ],
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.singleItemExclusive"
                                )
                              ) +
                              "\n              "
                          ),
                          _vm.hasShippingCostsCategoryId
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    "data-toggle": "modal",
                                    href: "#shippingscosts"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemShippingCosts"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _c("a", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemShippingCosts"
                                    )
                                  )
                                )
                              ])
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._t("additional-content-after-vat")
                    ],
                    2
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-md-7" }, [
                  _c("div", { staticClass: "my-5" }, [
                    _c(
                      "ul",
                      {
                        staticClass: "nav nav-tabs",
                        attrs: { role: "tablist" }
                      },
                      [
                        _vm.isDescriptionTabActive
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link active",
                                  attrs: {
                                    "data-toggle": "tab",
                                    href:
                                      "#details-" +
                                      _vm.currentVariation.variation.id,
                                    role: "tab"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemDescription"
                                      )
                                    )
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isTechnicalDataTabActive
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  class: {
                                    active:
                                      !_vm.isDescriptionTabActive &&
                                      _vm.isTechnicalDataTabActive
                                  },
                                  attrs: {
                                    "data-toggle": "tab",
                                    href:
                                      "#data-" +
                                      _vm.currentVariation.variation.id,
                                    role: "tab"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemTechnicalData"
                                      )
                                    )
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("li", { staticClass: "nav-item" }, [
                          _c(
                            "a",
                            {
                              staticClass: "nav-link",
                              class: {
                                active:
                                  !_vm.isDescriptionTabActive &&
                                  !_vm.isTechnicalDataTabActive
                              },
                              attrs: {
                                "data-toggle": "tab",
                                href: "#assessments-details",
                                role: "tab"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.singleItemMoreDetails"
                                  )
                                )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.currentVariation.variationProperties &&
                        _vm.currentVariation.variationProperties.length > 0
                          ? _c("li", { staticClass: "nav-item downloads" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  attrs: {
                                    "data-toggle": "tab",
                                    href: "#downloads",
                                    role: "tab"
                                  }
                                },
                                [_vm._v("Downloads")]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isEuResponsibleTabShown
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  attrs: {
                                    "data-toggle": "tab",
                                    href: "#eu-responsible",
                                    role: "tab"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemEuResponsiblePerson"
                                      )
                                    )
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isManufacturerTabShown
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  attrs: {
                                    "data-toggle": "tab",
                                    href: "#manufacturer",
                                    role: "tab"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemManufacturer"
                                      )
                                    )
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("li", { staticClass: "nav-item" }, [
                          _c(
                            "a",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                "data-toggle": "tab",
                                href: "#savety",
                                role: "tab"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "KMSVueTheme::SingleItemTheme.SavetyTab"
                                  )
                                )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm._t("add-detail-tabs")
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tab-content overflow-hidden" },
                      [
                        _vm.isDescriptionTabActive
                          ? _c(
                              "div",
                              {
                                staticClass: "tab-pane active overflow-auto",
                                attrs: {
                                  id:
                                    "details-" +
                                    _vm.currentVariation.variation.id,
                                  role: "tabpanel"
                                }
                              },
                              [
                                _c("div", {
                                  staticClass: "my-4",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentVariation.texts.description
                                    )
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isTechnicalDataTabActive
                          ? _c(
                              "div",
                              {
                                staticClass: "tab-pane overflow-auto",
                                class: {
                                  active:
                                    !_vm.isDescriptionTabActive &&
                                    _vm.isTechnicalDataTabActive
                                },
                                attrs: {
                                  id:
                                    "data-" + _vm.currentVariation.variation.id,
                                  role: "tabpanel"
                                }
                              },
                              [
                                _c("div", {
                                  staticClass: "my-4",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentVariation.texts.technicalData
                                    )
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "tab-pane overflow-auto",
                            class: {
                              active:
                                !_vm.isDescriptionTabActive &&
                                !_vm.isTechnicalDataTabActive
                            },
                            attrs: {
                              id: "assessments-details",
                              role: "tabpanel"
                            }
                          },
                          [
                            _c("div", { staticClass: "my-4" }, [
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "table table-striped table-hover table-sm"
                                },
                                [
                                  _c("tbody", [
                                    _vm.itemConfig.includes("item.id") ||
                                    _vm.itemConfig.includes("all")
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemId"
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.item.id
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.item.condition &&
                                    _vm.currentVariation.item.condition.names
                                      .name !== "" &&
                                    (_vm.itemConfig.includes(
                                      "item.condition"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemCondition"
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.currentVariation.item
                                                    .condition.names.name
                                                ) +
                                                "\n                        "
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.itemConfig.includes(
                                      "item.age_rating"
                                    ) || _vm.itemConfig.includes("all")
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemAge"
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm._f("ageRestriction")(
                                                    _vm.currentVariation.item
                                                      .ageRestriction
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.variation
                                      .externalId !== "" &&
                                    (_vm.itemConfig.includes(
                                      "item.external_id"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemExternalVariationId"
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.variation
                                                  .externalId
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.variation.model !==
                                      "" &&
                                    (_vm.itemConfig.includes(
                                      "item.variation_model"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemModel"
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.variation
                                                  .model
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.filter
                                      .hasManufacturer &&
                                    _vm.currentVariation.item.manufacturer
                                      .externalName !== "" &&
                                    (_vm.itemConfig.includes(
                                      "item.manufacturer"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemManufacturer"
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.currentVariation.item
                                                    .manufacturer.externalName
                                                ) +
                                                "\n                        "
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.item
                                      .producingCountry &&
                                    _vm.currentVariation.item.producingCountry
                                      .names.name !== "" &&
                                    (_vm.itemConfig.includes(
                                      "item.producerCountry"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemManufacturingCountry"
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.currentVariation.item
                                                    .producingCountry.names.name
                                                ) +
                                                "\n                        "
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.unit &&
                                    (_vm.itemConfig.includes(
                                      "item.variationBase_content"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemContent"
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.currentVariation.unit
                                                    .content
                                                ) +
                                                "\n                          " +
                                                _vm._s(
                                                  _vm.currentVariation.unit
                                                    .names.name
                                                ) +
                                                "\n                        "
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.variation.weightG !==
                                      "" &&
                                    (_vm.itemConfig.includes("item.weightG") ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemWeight"
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.variation
                                                  .weightG
                                              ) + " g"
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.variation
                                      .weightNetG !== "" &&
                                    (_vm.itemConfig.includes(
                                      "item.weightNetG"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemNetWeight"
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.variation
                                                  .weightNetG
                                              ) + " g"
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.itemConfig.includes(
                                      "item.variation_dimensions"
                                    ) || _vm.itemConfig.includes("all")
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemDimensions"
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .lengthMM
                                                )
                                              )
                                            ]),
                                            _vm._v("×"),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .widthMM
                                                )
                                              )
                                            ]),
                                            _vm._v("×"),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .heightMM
                                                )
                                              )
                                            ]),
                                            _vm._v(
                                              "\n                          mm\n                        "
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.variation
                                      .customsTariffNumber !== "" &&
                                    (_vm.itemConfig.includes(
                                      "variation.customs_tariff_number"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemCustomsTariffNumber"
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .customsTariffNumber
                                                ) +
                                                "\n                        "
                                            )
                                          ])
                                        ])
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "tab-pane overflow-auto",
                            attrs: { id: "downloads", role: "tabpanel" }
                          },
                          [
                            _vm.currentVariation.variationProperties &&
                            _vm.currentVariation.variationProperties.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "downloads my-4" },
                                  [
                                    _vm._l(
                                      _vm.currentVariation.variationProperties,
                                      function(
                                        variationProperty,
                                        variationIndex
                                      ) {
                                        return variationProperty.id === 2
                                          ? _vm._l(
                                              variationProperty.properties,
                                              function(property, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "mt-3"
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "d-inline-flex text-left flex-column-reverse",
                                                        attrs: {
                                                          href:
                                                            property.values
                                                              .value,
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "color-dark mt-2 font-weight-bold"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  property.names
                                                                    .name
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-file-pdf-o",
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          : _vm._e()
                                      }
                                    )
                                  ],
                                  2
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isEuResponsibleTabShown
                          ? _c(
                              "div",
                              {
                                staticClass: "tab-pane overflow-auto",
                                attrs: {
                                  id: "eu-responsible",
                                  role: "tabpanel"
                                }
                              },
                              [
                                _c("div", { staticClass: "my-4" }, [
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleName
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleStreet
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleHouseNo
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsiblePostCode
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleTown
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.currentVariation.item.manufacturer
                                      .responsibleCountryObject
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .manufacturer
                                                  .responsibleCountryObject.name
                                              ) +
                                              "\n                    "
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleEmail
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsiblePhoneNo
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleContactUrl
                                        )
                                      )
                                    ])
                                  ])
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isManufacturerTabShown
                          ? _c(
                              "div",
                              {
                                staticClass: "tab-pane overflow-auto",
                                attrs: { id: "manufacturer", role: "tabpanel" }
                              },
                              [
                                _c("div", { staticClass: "my-4" }, [
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .name
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .legalName
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .street
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .houseNo
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .postcode
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .town
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.currentVariation.item.manufacturer
                                      .countryObject
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .manufacturer.countryObject
                                                  .name
                                              ) +
                                              "\n                    "
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .email
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .url
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .phoneNumber
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .faxNumber
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .contactUrl
                                        )
                                      )
                                    ])
                                  ])
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(0),
                        _vm._v(" "),
                        _vm._t("add-detail-tabs-content")
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.currentVariation.variationProperties &&
                _vm.currentVariation.variationProperties.length > 0
                  ? _c(
                      "div",
                      { staticClass: "col-12 col-md-5 position-relative my-5" },
                      [
                        _vm.hasVideo()
                          ? _c(
                              "p",
                              {
                                staticClass: "mb-3 d-block h4 font-weight-bold"
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$translate(
                                        "KMSVueTheme::SingleItemTheme.YoutubeHeadline"
                                      )
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(
                          _vm.currentVariation.variationProperties,
                          function(variationProperty, variationIndex) {
                            return _c(
                              "div",
                              { key: variationIndex },
                              _vm._l(variationProperty.properties, function(
                                property,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "position-relative"
                                  },
                                  [
                                    property.id === 4
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "video-container" },
                                            [
                                              _c("iframe", {
                                                class: {
                                                  "blurred-video": !_vm.videoConsent
                                                },
                                                attrs: {
                                                  src:
                                                    "https://www.youtube-nocookie.com/embed/" +
                                                    property.values.value,
                                                  frameborder: "0",
                                                  allow:
                                                    "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                                                  allowfullscreen: ""
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          !_vm.videoConsent
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "video-overlay d-flex align-items-center justify-content-center"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center text-white"
                                                    },
                                                    [
                                                      _c("p", [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$translate(
                                                                "KMSVueTheme::SingleItemTheme.OverlayText"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-primary mt-2",
                                                          on: {
                                                            click: _vm.showVideo
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$translate(
                                                                  "KMSVueTheme::SingleItemTheme.OverlayButtonText"
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              }),
                              0
                            )
                          }
                        )
                      ],
                      2
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm._t("item-list-container"),
              _vm._v(" "),
              _vm._t("feedback-container"),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fs-sticky-cart-slide" } }, [
                _vm.showStickyCart
                  ? _c(
                      "div",
                      {
                        staticClass: "fs-sticky-cart",
                        attrs: { "aria-label": "In den Warenkorb" }
                      },
                      [
                        _c("div", { staticClass: "fs-sticky-cart__inner" }, [
                          _c(
                            "div",
                            {
                              staticClass: "fs-sticky-cart__thumb",
                              attrs: { "aria-hidden": "true" }
                            },
                            [
                              _vm.savingMoneyPercent > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "fs-sticky-discount d-flex align-items-center justify-content-center text-white font-weight-bold position-absolute"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "-" +
                                            _vm._s(_vm.savingMoneyPercent) +
                                            "%"
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.currentVariation.images &&
                              _vm.currentVariation.images.all &&
                              _vm.currentVariation.images.all.length
                                ? _c("img", {
                                    attrs: {
                                      src:
                                        _vm.currentVariation.images.all[0]
                                          .urlPreview ||
                                        _vm.currentVariation.images.all[0]
                                          .urlMiddle ||
                                        _vm.currentVariation.images.all[0].url,
                                      alt: _vm._f("itemName")(
                                        _vm.currentVariation
                                      ),
                                      loading: "lazy"
                                    }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "fs-sticky-cart__meta" }, [
                            _c(
                              "div",
                              { staticClass: "fs-sticky-cart__title" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("itemName")(_vm.currentVariation)
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "fs-sticky-cart__price" },
                              [
                                _c("item-price", {
                                  attrs: { "show-cross-price": false }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "fs-sticky-cart__cta" },
                            [
                              _c("add-to-basket", {
                                attrs: {
                                  "variation-id":
                                    _vm.currentVariation.variation.id,
                                  "is-salable":
                                    !!_vm.currentVariation.filter &&
                                    _vm.currentVariation.filter.isSalable,
                                  "has-children":
                                    !!_vm.currentVariation.filter &&
                                    _vm.currentVariation.filter
                                      .hasActiveChildren,
                                  "interval-quantity":
                                    _vm.currentVariation.variation
                                      .intervalOrderQuantity || 1,
                                  "minimum-quantity":
                                    _vm.currentVariation.variation
                                      .minimumOrderQuantity,
                                  "maximum-quantity":
                                    !!_vm.currentVariation.variation
                                      .maximumOrderQuantity &&
                                    _vm.currentVariation.variation
                                      .maximumOrderQuantity > 0
                                      ? _vm.currentVariation.variation
                                          .maximumOrderQuantity
                                      : null,
                                  "order-properties": _vm.currentVariation.properties.filter(
                                    function(prop) {
                                      return prop.property.isOderProperty
                                    }
                                  ),
                                  "has-order-properties":
                                    _vm.currentVariation.hasOrderProperties,
                                  "has-required-order-property":
                                    _vm.currentVariation
                                      .hasRequiredOrderProperty,
                                  "use-large-scale": false,
                                  "show-quantity": false,
                                  "item-url": _vm._f("itemURL")(
                                    _vm.currentVariation
                                  ),
                                  "is-variation-selected":
                                    _vm.isVariationSelected &&
                                    _vm.currentVariation.filter.isSalable,
                                  "has-price": _vm._f("hasItemDefaultPrice")(
                                    _vm.currentVariation
                                  )
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            ],
            2
          )
        ],
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "tab-pane overflow-auto",
        attrs: { id: "savety", role: "tabpanel" }
      },
      [
        _c("div", { staticClass: "my-4" }, [
          _c("div", { staticClass: "p-0" }, [
            _c(
              "div",
              {
                staticClass: "widget widget-accordion widget-none",
                attrs: { id: "accordion_67921b7679be1" }
              },
              [
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_1",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_1",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_1"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Deutsch\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_1",
                        "aria-labelledby": "heading_67921b7679be1_1",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [_vm._v("Produktsicherheitshinweis")])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("strong", [_vm._v(" ")])]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Ihre Sicherheit steht bei uns an erster Stelle. Unsere Produkte entsprechen den Anforderungen der EU-Produktsicherheitsverordnung (EU) 2023/988 und erfüllen höchste\n                              Sicherheits- und Qualitätsstandards für die Gewährleistung eines reibungslosen Geräte-Betriebs.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Unsere Verpflichtungen zur Produktsicherheit"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("br"),
                          _vm._v("Einhaltung von EU-Richtlinien:")
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Alle unsere Produkte werden gemäß den geltenden Sicherheits- und Gesundheitsvorschriften entwickelt und getestet."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("p", [_vm._v("Risikobewertung und Qualität:")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Jedes Produkt durchläuft umfassende Prüfverfahren, um maximale Sicherheit und Funktionalität zu gewährleisten."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("p", [_vm._v("Sicherheitsinformationen:")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Unsere Produkte werden mit detaillierten Anleitungen und Sicherheitsvorgaben geliefert, die unbedingt vor der Nutzung zu lesen und zu befolgen sind."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Wichtige Hinweise für die sichere Nutzung"),
                            _c("br")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Original-Ersatzteile verwenden:")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Wir empfehlen dringend, ausschließlich Original-Ersatzteile zu verwenden. Der Einsatz nicht geprüfter Teile kann die Sicherheit und Funktionstüchtigkeit des Geräts\n                              beeinträchtigen.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Keine Manipulation oder Zweckentfremdung:")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Bitte verändern oder manipulieren Sie das Gerät nicht manuell und verwenden Sie es nur entsprechend der vorgesehenen Bestimmung."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Vom Stromnetz trennen:")])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Falls Wartungsarbeiten erforderlich sind, stellen Sie sicher, dass das Gerät vollständig vom Stromnetz getrennt ist, um elektrische Gefahren auszuschließen."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Gebrauchsanleitung beachten:")])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Folgen Sie stets den Anweisungen in der Benutzerhandbuch oder Gebrauchsanleitung des Herstellers. Abweichungen können zu Fehlfunktionen oder Sicherheitsrisiken führen.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Technischen Kundenservice kontaktieren:")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Im Zweifelsfall oder bei Problemen mit Ihrem Gerät steht unser technischer Kundenservice bereit, um Sie kompetent zu unterstützen."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Ihre Verantwortung als Nutzer:")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Lesen und verstehen Sie alle Sicherheits- und Bedienungshinweise sorgfältig."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Nutzen Sie das Gerät ausschließlich in der vorgesehenen Weise und Umgebung."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Bewahren Sie das Gerät sicher auf und außerhalb der Reichweite von Kindern, sofern es nicht ausdrücklich für deren Nutzung bestimmt ist."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Kontakt zu unserem Kundenservice:")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Für Unterstützung oder Rückfragen stehen wir Ihnen jederzeit zur Verfügung:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("br"),
                          _vm._v("E-Mail: kundenservice@kms-handel.de")
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v("Telefon: +49 5921 81 999 - 0")]),
                        _vm._v(" "),
                        _c("p", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Ihr Vertrauen ist unsere Verantwortung. Mit unseren Produkten und Ihrem sicheren Umgang sorgen wir gemeinsam dafür, dass Sie hochwertige Unterhaltung sorgenfrei\n                              genießen können.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v(" ")])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_2",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_2",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_2"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            English\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_2",
                        "aria-labelledby": "heading_67921b7679be1_2",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [_vm._v("Product Safety Notice")])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Your safety is our top priority. Our products comply with the requirements of the EU Product Safety Regulation (EU) 2023/988 and meet the highest safety and quality\n                              standards to ensure smooth device operation.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Our Commitments to Product Safety")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Compliance with EU Directives:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "All our products are developed and tested in accordance with applicable safety and health regulations."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Risk Assessment and Quality:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Every product undergoes comprehensive testing procedures to ensure maximum safety and functionality."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Safety Information:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Our products are delivered with detailed instructions and safety guidelines, which must be read and followed before use."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Important Notes for Safe Use")])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Use Original Spare Parts:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "We strongly recommend using only original spare parts. The use of untested parts can compromise the safety and\n                              functionality of the device.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("No Tampering or Misuse:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Please do not manually modify or tamper with the device and use it only as intended."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Disconnect from the Power Supply:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "If maintenance is required, ensure the device is completely disconnected from the power supply to eliminate\n                              electrical hazards.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Follow the User Manual:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Always adhere to the instructions in the user manual or operating guide provided by the manufacturer. Deviations may\n                              result in malfunctions or safety risks.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Contact Technical Customer Service:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "If in doubt or if you encounter any issues with your device, our technical customer service team is available\n                              to assist you competently.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Your Responsibility as a User")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Carefully read and understand all safety and operating instructions."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Use the device only in the intended manner and environment."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Store the device securely and out of reach of children unless explicitly designed for their use."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Contact Our Customer Service")])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "For support or inquiries, we are always available to assist you:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("Email:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Phone:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Your trust is our responsibility. Together, with our products and your safe handling, we ensure that you can enjoy high-quality entertainment worry-free."
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_3",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_3",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_3"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Français\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_3",
                        "aria-labelledby": "heading_67921b7679be1_3",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [
                            _vm._v("Avis de sécurité des produits")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Votre sécurité est notre priorité absolue. Nos produits sont conformes aux exigences du Règlement de sécurité des produits de l'UE (UE) 2023/988 et répondent aux normes\n                              de sécurité et de qualité les plus élevées pour garantir un fonctionnement sans faille de vos appareils.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Nos engagements en matière de sécurité des produits"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Conformité aux directives européennes :")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Tous nos produits sont développés et testés conformément aux réglementations en vigueur en matière de\n                              sécurité et de santé.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Évaluation des risques et qualité :")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Chaque produit est soumis à des procédures de tests approfondies afin de garantir une sécurité et une\n                              fonctionnalité maximales.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Informations de sécurité :")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Nos produits sont livrés avec des instructions détaillées et des consignes de sécurité, qui doivent être lues et\n                              respectées avant toute utilisation.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Consignes importantes pour une utilisation en toute sécurité"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Utiliser des pièces de rechange d'origine :"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Nous recommandons vivement d'utiliser uniquement des pièces de rechange d'origine. L'utilisation de\n                              pièces non testées peut compromettre la sécurité et le bon fonctionnement de l'appareil.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Ne pas modifier ni détourner l'usage prévu:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Veuillez ne pas modifier ou manipuler l'appareil manuellement et l'utiliser uniquement selon l'usage\n                              prévu.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Débrancher l'appareil :")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "En cas de travaux de maintenance, assurez-vous que l'appareil est entièrement déconnecté du réseau électrique afin\n                              d'éliminer tout risque électrique.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Suivre le mode d'emploi :")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Respectez toujours les instructions du manuel ou du guide d'utilisation fourni par le fabricant. Toute déviation peut\n                              entraîner des dysfonctionnements ou des risques pour la sécurité.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Contacter le service clientèle technique :")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "En cas de doute ou de problème avec votre appareil, notre service clientèle technique est disponible\n                              pour vous offrir une assistance compétente.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Votre responsabilité en tant qu’utilisateur"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Lisez attentivement et comprenez toutes les consignes de sécurité et d'utilisation."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Utilisez l'appareil uniquement de manière appropriée et dans l'environnement prévu."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Rangez l'appareil en toute sécurité et hors de portée des enfants, sauf s'il est explicitement conçu pour leur usage."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Contactez notre service clientèle")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Pour toute assistance ou question, nous sommes toujours à votre disposition :"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("E-mail :")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Téléphone :")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Votre confiance est notre responsabilité. Avec nos produits et votre utilisation en toute sécurité, nous veillons ensemble à ce que vous puissiez profiter pleinement de\n                              divertissements de qualité en toute sérénité.\n                            "
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_4",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_4",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_4"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Italiano\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_4",
                        "aria-labelledby": "heading_67921b7679be1_4",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [
                            _vm._v("Avviso di sicurezza del prodotto")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              La vostra sicurezza è la nostra priorità assoluta. I nostri prodotti sono conformi ai requisiti del Regolamento sulla sicurezza dei prodotti dell'UE (UE) 2023/988 e\n                              rispettano i più alti standard di sicurezza e qualità per garantire un funzionamento regolare dei dispositivi.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "I nostri impegni per la sicurezza del prodotto"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Conformità alle direttive UE:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Tutti i nostri prodotti sono sviluppati e testati in conformità con le normative vigenti in materia di sicurezza e\n                              salute.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Valutazione dei rischi e qualità:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Ogni prodotto è sottoposto a procedure di test approfondite per garantire la massima sicurezza e funzionalità.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Informazioni sulla sicurezza:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "I nostri prodotti sono forniti con istruzioni dettagliate e linee guida di sicurezza che devono essere lette e\n                              seguite prima dell'uso.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Indicazioni importanti per un utilizzo sicuro"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Utilizzare solo ricambi originali:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Raccomandiamo vivamente di utilizzare esclusivamente ricambi originali. L'uso di componenti non testati può\n                              compromettere la sicurezza e il funzionamento del dispositivo.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Non modificare o usare impropriamente il dispositivo:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Si prega di non modificare manualmente il dispositivo e di utilizzarlo solo per l'uso\n                              previsto.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Scollegare dalla rete elettrica:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "In caso di interventi di manutenzione, assicurarsi che il dispositivo sia completamente scollegato dalla rete\n                              elettrica per evitare rischi elettrici.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Seguire il manuale d'uso:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Attenersi sempre alle istruzioni fornite nel manuale d'uso o nella guida del produttore. Eventuali deviazioni possono\n                              causare malfunzionamenti o rischi per la sicurezza.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Contattare il servizio clienti tecnico:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "In caso di dubbi o problemi con il dispositivo, il nostro servizio clienti tecnico è a disposizione per\n                              offrirvi assistenza competente.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("La vostra responsabilità come utente")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Leggete attentamente e comprendete tutte le istruzioni di sicurezza e di utilizzo."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Utilizzate il dispositivo esclusivamente in modo appropriato e nell'ambiente previsto."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Conservate il dispositivo in modo sicuro e fuori dalla portata dei bambini, salvo diversa indicazione per il loro utilizzo."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Contattare il nostro servizio clienti")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Per assistenza o domande, siamo sempre a vostra disposizione:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("E-mail:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Telefono:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              La vostra fiducia è la nostra responsabilità. Con i nostri prodotti e il vostro utilizzo sicuro, garantiamo insieme che possiate godere di un intrattenimento di alta\n                              qualità senza preoccupazioni.\n                            "
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_5",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_5",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_5"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Nederlands\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_5",
                        "aria-labelledby": "heading_67921b7679be1_5",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [
                            _vm._v("Productveiligheidswaarschuwing")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Uw veiligheid staat bij ons op de eerste plaats. Onze producten voldoen aan de eisen van de EU-verordening productveiligheid (EU) 2023/988 en voldoen aan de hoogste\n                              veiligheids- en kwaliteitsnormen om een probleemloze werking van de apparaten te garanderen.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Onze verplichtingen op het gebied van productveiligheid"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Naleving van EU-richtlijnen:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Al onze producten worden ontwikkeld en getest in overeenstemming met de geldende veiligheids- en\n                              gezondheidsvoorschriften.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Risicobeoordeling en kwaliteit:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Elk product ondergaat uitgebreide testprocedures om maximale veiligheid en functionaliteit te waarborgen."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Veiligheidsinformatie:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Onze producten worden geleverd met gedetailleerde handleidingen en veiligheidsrichtlijnen die vóór gebruik zorgvuldig\n                              moeten worden gelezen en opgevolgd.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Belangrijke aanwijzingen voor veilig gebruik"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Gebruik originele reserveonderdelen:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Wij raden sterk aan uitsluitend originele reserveonderdelen te gebruiken. Het gebruik van niet-geteste\n                              onderdelen kan de veiligheid en functionaliteit van het apparaat in gevaar brengen.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Geen manipulatie of oneigenlijk gebruik:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Wijzig of manipuleer het apparaat niet handmatig en gebruik het uitsluitend volgens de voorgeschreven\n                              doeleinden.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Loskoppelen van het stroomnet:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Zorg er bij onderhoudswerkzaamheden voor dat het apparaat volledig is losgekoppeld van het stroomnet om\n                              elektrische gevaren te voorkomen.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Houd u aan de gebruiksaanwijzing:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Volg altijd de instructies in de handleiding of gebruiksaanwijzing van de fabrikant. Afwijkingen hiervan kunnen\n                              leiden tot storingen of veiligheidsrisico’s.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Neem contact op met de technische klantenservice:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Bij twijfel of problemen met uw apparaat staat onze technische klantenservice klaar om u\n                              deskundig te ondersteunen.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Uw verantwoordelijkheid als gebruiker")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Lees en begrijp alle veiligheids- en bedieningsinstructies zorgvuldig."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Gebruik het apparaat uitsluitend op de voorgeschreven wijze en in de daarvoor bedoelde omgeving."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Bewaar het apparaat op een veilige plaats en buiten bereik van kinderen, tenzij het uitdrukkelijk is bedoeld voor gebruik door hen."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Contact met onze klantenservice")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Voor ondersteuning of vragen staan wij altijd tot uw beschikking:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("E-mail:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Telefoon:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Uw vertrouwen is onze verantwoordelijkheid. Samen zorgen we, met onze producten en uw veilige gebruik, ervoor dat u zorgeloos kunt genieten van hoogwaardige\n                              entertainment.\n                            "
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_6",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_6",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_6"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Български\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_6",
                        "aria-labelledby": "heading_67921b7679be1_6",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [
                            _vm._v("Съобщение за безопасност на продуктите")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Вашата безопасност е наш основен приоритет. Нашите продукти отговарят на изискванията на Регламента за безопасност на продуктите на ЕС (ЕС) 2023/988 и покриват\n                              най-високите стандарти за безопасност и качество, за да се гарантира безпроблемната работа на устройствата.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Нашите ангажименти към безопасността на продуктите"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Съответствие с директивите на ЕС:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Всички наши продукти се разработват и тестват в съответствие с действащите разпоредби за безопасност и здраве.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Оценка на риска и качество:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Всеки продукт преминава през обширни процедури за тестване, за да се гарантира максимална безопасност и\n                              функционалност.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Информация за безопасност:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Нашите продукти се доставят с подробни инструкции и насоки за безопасност, които трябва да бъдат прочетени и спазвани\n                              преди употреба.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Важни указания за безопасна употреба")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Използвайте оригинални резервни части:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Настоятелно препоръчваме да използвате само оригинални резервни части. Употребата на неизпитани части може\n                              да компрометира безопасността и функционалността на устройството.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Не модифицирайте и не използвайте неправомерно устройството:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Моля, не модифицирайте ръчно устройството и го използвайте само по предназначение.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Изключете от електрическата мрежа:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "При необходимост от поддръжка се уверете, че устройството е напълно изключено от електрическата мрежа, за да\n                              избегнете електрически опасности.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Спазвайте ръководството за употреба:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Винаги следвайте инструкциите, посочени в ръководството или наръчника на производителя. Отклоненията от тях\n                              могат да доведат до неизправности или рискове за безопасността.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Свържете се с техническата поддръжка:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "При съмнения или проблеми с устройството, нашият екип за техническа поддръжка е на разположение да ви\n                              осигури компетентна помощ.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Вашата отговорност като потребител")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Прочетете внимателно и разберете всички инструкции за безопасност и употреба."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Използвайте устройството само по предназначение и в предвидената среда."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Съхранявайте устройството на сигурно място, далеч от деца, освен ако не е изрично предназначено за тяхна употреба."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Контакт с нашата клиентска поддръжка")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("За съдействие или въпроси сме винаги на ваше")
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_7",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_7",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_7"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Suomalainen\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_7",
                        "aria-labelledby": "heading_67921b7679be1_7",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [_vm._v("Tuoteturvallisuushuomautus")])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Turvallisuutesi on meille ensisijaisen tärkeää. Tuotteemme täyttävät EU:n tuoteturvallisuusasetuksen (EU) 2023/988 vaatimukset ja noudattavat korkeimpia turvallisuus-\n                              ja laatuvaatimuksia laitteen sujuvan toiminnan takaamiseksi.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Sitoutumisemme tuoteturvallisuuteen")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("EU-direktiivien noudattaminen:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Kaikki tuotteemme suunnitellaan ja testataan voimassa olevien turvallisuus- ja terveyssäännösten mukaisesti."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Riskiarviointi ja laatu:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Jokainen tuote käy läpi kattavat testausprosessit, joilla varmistetaan maksimaalinen turvallisuus ja toiminnallisuus.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Turvallisuustiedot:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Tuotteemme toimitetaan yksityiskohtaisten käyttöohjeiden ja turvallisuusmääräysten kanssa, jotka on luettava ja noudatettava\n                              ennen käyttöä.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Tärkeitä ohjeita turvalliseen käyttöön")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Käytä alkuperäisiä varaosia:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Suosittelemme käyttämään vain alkuperäisiä varaosia. Testaamattomien osien käyttö voi vaarantaa laitteen\n                              turvallisuuden ja toimivuuden.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Älä muokkaa tai käytä laitetta väärin:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Älä muokkaa tai käsittele laitetta itse ja käytä sitä vain suunniteltuun tarkoitukseen."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Irrota laite sähköverkosta:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Jos huoltotöitä tarvitaan, varmista, että laite on täysin irrotettu sähköverkosta sähkövaarojen välttämiseksi."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Noudata käyttöohjetta:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Noudata aina valmistajan antamia käyttöohjeita. Poikkeamat voivat johtaa toimintahäiriöihin tai turvallisuusriskeihin.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Ota yhteyttä tekniseen asiakaspalveluun:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Jos olet epävarma tai kohtaat ongelmia laitteesi kanssa, tekninen asiakaspalvelumme on käytettävissäsi\n                              tarjoamaan asiantuntevaa apua.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [_c("strong", [_vm._v("Käyttäjän vastuu")])]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Lue ja ymmärrä kaikki turvallisuus- ja käyttöohjeet huolellisesti."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Käytä laitetta vain sen suunnitellulla tavalla ja ympäristössä."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Säilytä laite turvallisesti ja lasten ulottumattomissa, ellei sitä ole erityisesti tarkoitettu heidän käyttöönsä."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Ota yhteyttä asiakaspalveluumme")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Tarvitsetko tukea tai onko kysyttävää? Olemme aina käytettävissäsi:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("Sähköposti:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Puhelin:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Luottamuksesi on meidän vastuumme. Yhdessä tuotteidemme ja turvallisen käytön avulla varmistamme, että voit nauttia korkealaatuisesta viihteestä huolettomasti."
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_8",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_8",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_8"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Ελληνική\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_8",
                        "aria-labelledby": "heading_67921b7679be1_8",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [
                            _vm._v("Ειδοποίηση Ασφάλειας Προϊόντος")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Η ασφάλειά σας είναι η πρώτη μας προτεραιότητα. Τα προϊόντα μας συμμορφώνονται με τις απαιτήσεις του Κανονισμού Ασφάλειας Προϊόντων της ΕΕ (ΕΕ) 2023/988 και πληρούν τα\n                              υψηλότερα πρότυπα ασφάλειας και ποιότητας για την εξασφάλιση της ομαλής λειτουργίας των συσκευών.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Οι δεσμεύσεις μας για την ασφάλεια των προϊόντων"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Συμμόρφωση με τις Οδηγίες της ΕΕ:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Όλα τα προϊόντα μας αναπτύσσονται και δοκιμάζονται σύμφωνα με τις ισχύουσες διατάξεις για την ασφάλεια και την\n                              υγεία.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Αξιολόγηση κινδύνων και ποιότητα:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Κάθε προϊόν υποβάλλεται σε εκτενείς διαδικασίες δοκιμών για να διασφαλιστεί η μέγιστη ασφάλεια και\n                              λειτουργικότητα.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Πληροφορίες για την ασφάλεια:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Τα προϊόντα μας παρέχονται με λεπτομερείς οδηγίες και κατευθυντήριες γραμμές ασφαλείας, οι οποίες πρέπει να\n                              διαβάζονται και να τηρούνται πριν από τη χρήση.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Σημαντικές οδηγίες για ασφαλή χρήση")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Χρησιμοποιήστε γνήσια ανταλλακτικά:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Σας συνιστούμε ανεπιφύλακτα να χρησιμοποιείτε μόνο γνήσια ανταλλακτικά. Η χρήση μη ελεγμένων εξαρτημάτων\n                              μπορεί να θέσει σε κίνδυνο την ασφάλεια και τη λειτουργικότητα της συσκευής.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Μην τροποποιείτε ή χρησιμοποιείτε το προϊόν για άλλους σκοπούς:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Παρακαλούμε να μην τροποποιείτε χειροκίνητα τη συσκευή και να τη χρησιμοποιείτε\n                              μόνο σύμφωνα με τον προβλεπόμενο σκοπό της.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Αποσύνδεση από το ηλεκτρικό δίκτυο:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Εάν απαιτούνται εργασίες συντήρησης, βεβαιωθείτε ότι η συσκευή είναι πλήρως αποσυνδεδεμένη από το ηλεκτρικό\n                              δίκτυο για την αποφυγή ηλεκτροπληξίας.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Ακολουθήστε το εγχειρίδιο χρήσης:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Πάντα να ακολουθείτε τις οδηγίες που παρέχονται στο εγχειρίδιο χρήσης ή στον οδηγό του κατασκευαστή. Οι\n                              αποκλίσεις μπορεί να οδηγήσουν σε δυσλειτουργίες ή κινδύνους ασφαλείας.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Επικοινωνήστε με την τεχνική υποστήριξη:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Σε περίπτωση αμφιβολιών ή προβλημάτων με τη συσκευή σας, η τεχνική υποστήριξή μας είναι διαθέσιμη για να\n                              σας προσφέρει επαγγελματική βοήθεια.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Η ευθύνη σας ως χρήστης")])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Διαβάστε και κατανοήστε προσεκτικά όλες τις οδηγίες ασφαλείας και χρήσης."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Χρησιμοποιήστε τη συσκευή αποκλειστικά με τον προβλεπόμενο τρόπο και στο κατάλληλο περιβάλλον."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Αποθηκεύστε τη συσκευή με ασφάλεια και μακριά από παιδιά, εκτός αν προορίζεται ρητά για τη χρήση τους."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Επικοινωνία με την υποστήριξη πελατών μας")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Για βοήθεια ή ερωτήσεις, είμαστε πάντα στη διάθεσή σας:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("Email:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Τηλέφωνο:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Η εμπιστοσύνη σας είναι η ευθύνη μας. Μαζί, με τα προϊόντα μας και τη δική σας ασφαλή χρήση, διασφαλίζουμε ότι μπορείτε να απολαμβάνετε υψηλής ποιότητας ψυχαγωγία χωρίς\n                              ανησυχίες.\n                            "
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_9",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_9",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_9"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Norsk\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_9",
                        "aria-labelledby": "heading_67921b7679be1_9",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [_vm._v("Produkt sikkerhetsvarsel")])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Din sikkerhet er vår høyeste prioritet. Våre produkter er i samsvar med kravene i EU-forordningen om produktsikkerhet (EU) 2023/988 og oppfyller de høyeste sikkerhets-\n                              og kvalitetsstandardene for å sikre problemfri drift av enhetene.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Våre forpliktelser til produktsikkerhet")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Overholdelse av EU-direktiver:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Alle våre produkter er utviklet og testet i samsvar med gjeldende sikkerhets- og helseforskrifter."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Risikvurdering og kvalitet:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Hvert produkt gjennomgår omfattende testprosedyrer for å sikre maksimal sikkerhet og funksjonalitet."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Sikkerhetsinformasjon:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Våre produkter leveres med detaljerte instruksjoner og sikkerhetsretningslinjer som må leses og følges før bruk."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Viktige instruksjoner for sikker bruk")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Bruk originale reservedeler:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Vi anbefaler på det sterkeste å bruke kun originale reservedeler. Bruk av utestede deler kan påvirke enhetens\n                              sikkerhet og funksjonalitet.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Ikke manipuler eller misbruk enheten:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Vennligst manipuler ikke enheten manuelt og bruk den kun i henhold til dens opprinnelige formål."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Koble fra strømnettet:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Ved vedlikehold, vær sikker på at enheten er helt frakoblet strømnettet for å unngå elektriske farer."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Følg bruksanvisningen:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Følg alltid instruksjonene i brukerhåndboken eller produsentens veiledning. Avvik kan føre til funksjonsfeil eller\n                              sikkerhetsrisikoer.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Kontakt teknisk kundeservice:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Ved tvil eller problemer med enheten, er vår tekniske kundeservice tilgjengelig for å gi kompetent hjelp."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Ditt ansvar som bruker")])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Les og forstå alle sikkerhets- og bruksanvisninger nøye."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Bruk enheten kun på den tiltenkte måten og i det angitte miljøet."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Oppbevar enheten på et sikkert sted, utenfor rekkevidde for barn, med mindre den er eksplisitt laget for deres bruk."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Kontakt vår kundeservice")])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "For støtte eller spørsmål er vi alltid tilgjengelig:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("E-post:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Telefon:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Din tillit er vårt ansvar. Sammen, med våre produkter og din sikre bruk, sørger vi for at du kan nyte høykvalitets underholdning uten bekymringer."
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_10",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_10",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_10"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Polski\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_10",
                        "aria-labelledby": "heading_67921b7679be1_10",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [
                            _vm._v("Powiadomienie o bezpieczeństwie produktu")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Twoje bezpieczeństwo jest dla nas najważniejsze. Nasze produkty spełniają wymagania rozporządzenia UE w sprawie bezpieczeństwa produktów (UE) 2023/988 i spełniają\n                              najwyższe standardy bezpieczeństwa i jakości, zapewniając bezproblemową obsługę urządzeń.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Nasze zobowiązania w zakresie bezpieczeństwa produktu"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Zgodność z dyrektywami UE:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Wszystkie nasze produkty są opracowywane i testowane zgodnie z obowiązującymi przepisami dotyczącymi bezpieczeństwa i\n                              zdrowia.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Ocena ryzyka i jakość:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Każdy produkt przechodzi szczegółowe procedury testowe w celu zapewnienia maksymalnego bezpieczeństwa i funkcjonalności.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Informacje dotyczące bezpieczeństwa:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Nasze produkty są dostarczane z szczegółowymi instrukcjami oraz wytycznymi bezpieczeństwa, które należy\n                              przeczytać i przestrzegać przed użyciem.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Ważne wskazówki dotyczące bezpiecznego użytkowania"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Używaj tylko oryginalnych części zamiennych:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Zalecamy używanie wyłącznie oryginalnych części zamiennych. Używanie nieprzetestowanych części może\n                              wpłynąć na bezpieczeństwo i sprawność urządzenia.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Nie modyfikuj ani nie używaj urządzenia w niewłaściwy sposób:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Prosimy nie modyfikować urządzenia ręcznie i używać go wyłącznie zgodnie z jego\n                              przeznaczeniem.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Odłącz urządzenie od sieci elektrycznej:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Jeśli konieczne są prace konserwacyjne, upewnij się, że urządzenie jest całkowicie odłączone od sieci\n                              elektrycznej, aby uniknąć zagrożeń elektrycznych.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Przestrzegaj instrukcji obsługi:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Zawsze postępuj zgodnie z instrukcjami zawartymi w podręczniku użytkownika lub instrukcji obsługi producenta.\n                              Odbiegnięcie od nich może prowadzić do awarii lub zagrożeń dla bezpieczeństwa.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Skontaktuj się z obsługą techniczną:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "W razie wątpliwości lub problemów z urządzeniem, nasza obsługa techniczna jest gotowa, aby udzielić Ci\n                              fachowej pomocy.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Twoja odpowiedzialność jako użytkownika")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Dokładnie przeczytaj i zrozum wszystkie instrukcje dotyczące bezpieczeństwa i użytkowania."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Używaj urządzenia wyłącznie w sposób zamierzony i w odpowiednich warunkach."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Przechowuj urządzenie w bezpiecznym miejscu, poza zasięgiem dzieci, chyba że jest ono przeznaczone do użytku przez dzieci."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Kontakt z naszą obsługą klienta")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "W przypadku wsparcia lub pytań jesteśmy do Twojej dyspozycji:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("E-mail:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Telefon:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Twoje zaufanie to nasza odpowiedzialność. Razem, z naszymi produktami i Twoim bezpiecznym użytkowaniem, zadbamy o to, abyś mógł cieszyć się wysokiej jakości rozrywką\n                              bez obaw.\n                            "
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_11",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_11",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_11"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Português\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_11",
                        "aria-labelledby": "heading_67921b7679be1_11",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [
                            _vm._v("Aviso de Segurança do Produto")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              A sua segurança é a nossa principal prioridade. Os nossos produtos cumprem os requisitos do Regulamento de Segurança de Produtos da UE (UE) 2023/988 e atendem aos mais\n                              elevados padrões de segurança e qualidade para garantir o funcionamento sem problemas dos dispositivos.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Os nossos compromissos com a segurança do produto"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Cumprimento das diretivas da UE:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Todos os nossos produtos são desenvolvidos e testados de acordo com as regulamentações de segurança e saúde em\n                              vigor.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Avaliação de riscos e qualidade:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Cada produto passa por procedimentos de teste abrangentes para garantir a máxima segurança e funcionalidade.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Informações de segurança:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Os nossos produtos são fornecidos com instruções detalhadas e diretrizes de segurança, que devem ser lidas e seguidas\n                              antes do uso.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Instruções importantes para o uso seguro")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Utilize peças de reposição originais:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Recomendamos vivamente que utilize apenas peças de reposição originais. O uso de peças não testadas pode\n                              comprometer a segurança e a funcionalidade do dispositivo.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Não manipule ou utilize o dispositivo de forma indevida:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Por favor, não modifique o dispositivo manualmente e utilize-o apenas para o fim a que\n                              se destina.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Desligue da rede elétrica:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Caso seja necessária manutenção, certifique-se de que o dispositivo está completamente desligado da rede elétrica para\n                              evitar riscos elétricos.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Siga o manual de instruções:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Siga sempre as instruções do manual do utilizador ou as diretrizes do fabricante. Desvios podem causar mau\n                              funcionamento ou riscos de segurança.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Contacte o serviço técnico de apoio ao cliente:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Em caso de dúvidas ou problemas com o seu dispositivo, o nosso serviço técnico está disponível\n                              para lhe prestar apoio competente.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("A sua responsabilidade como utilizador")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Leia e compreenda todas as instruções de segurança e operação com atenção."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Utilize o dispositivo apenas de acordo com a sua finalidade e no ambiente adequado."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Guarde o dispositivo em local seguro e fora do alcance das crianças, a menos que seja especificamente destinado para o seu uso."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Contacte o nosso serviço de apoio ao cliente"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Para apoio ou questões, estamos sempre à sua disposição:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("E-mail:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Telefone:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              A sua confiança é a nossa responsabilidade. Juntos, com os nossos produtos e o seu uso seguro, garantimos que pode desfrutar de entretenimento de alta qualidade sem\n                              preocupações.\n                            "
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_12",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_12",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_12"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Svensk\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_12",
                        "aria-labelledby": "heading_67921b7679be1_12",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [_vm._v("Produkt Säkerhetsinformation")])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Din säkerhet är vår högsta prioritet. Våra produkter uppfyller kraven i EU-förordningen om produktsäkerhet (EU) 2023/988 och uppfyller de högsta säkerhets- och\n                              kvalitetsstandarderna för att säkerställa att enheten fungerar problemfritt.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Våra åtaganden för produktsäkerhet")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Följa EU-direktiv:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Alla våra produkter utvecklas och testas i enlighet med gällande säkerhets- och hälsoregler."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Riskbedömning och kvalitet:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Varje produkt genomgår omfattande testprocedurer för att säkerställa maximal säkerhet och funktionalitet."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Säkerhetsinformation:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Våra produkter levereras med detaljerade instruktioner och säkerhetsriktlinjer som måste läsas och följas innan användning.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Viktiga anvisningar för säker användning")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Använd endast originalreservdelar:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Vi rekommenderar starkt att du använder enbart originalreservdelar. Användning av obeprövade delar kan påverka\n                              enhetens säkerhet och funktionalitet.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Manipulera eller använd inte enheten felaktigt:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Vänligen modifiera inte enheten manuellt och använd den endast för dess avsedda ändamål."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Koppla bort från elnätet:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Vid underhåll, se till att enheten är helt frånkopplad från elnätet för att undvika elektriska faror."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Följ bruksanvisningen:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Följ alltid instruktionerna i användarmanualen eller tillverkarens anvisningar. Avvikelser kan orsaka felaktig funktion\n                              eller säkerhetsrisker.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Kontakta teknisk kundservice:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Vid tveksamheter eller problem med din enhet är vår tekniska kundservice tillgänglig för att ge kompetent hjälp.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Ditt ansvar som användare")])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Läs och förstå noggrant alla säkerhets- och användarinstruktioner."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Använd enheten endast på det sätt och i den miljö som den är avsedd för."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Förvara enheten på en säker plats och utom räckhåll för barn, om den inte är specifikt avsedd för deras användning."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Kontakta vår kundservice")])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "För support eller frågor står vi alltid till ditt förfogande:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("E-post:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Telefon:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Din tillit är vårt ansvar. Tillsammans, med våra produkter och din säkra användning, säkerställer vi att du kan njuta av högkvalitativ underhållning utan bekymmer."
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_13",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_13",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_13"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Slovensky\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_13",
                        "aria-labelledby": "heading_67921b7679be1_13",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [
                            _vm._v("Upozornenie na bezpečnosť produktu")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Vaša bezpečnosť je pre nás na prvom mieste. Naše produkty spĺňajú požiadavky Nariadenia EÚ o bezpečnosti výrobkov (EÚ) 2023/988 a spĺňajú najvyššie bezpečnostné a\n                              kvalitné štandardy na zabezpečenie bezproblémovej prevádzky zariadení.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Naše záväzky v oblasti bezpečnosti produktu"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Dodržiavanie smerníc EÚ:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Všetky naše produkty sú vyvinuté a testované v súlade s platnými bezpečnostnými a zdravotnými predpismi."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Hodnotenie rizík a kvalita:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Každý produkt prechádza rozsiahlymi testovacími procedúrami na zabezpečenie maximálnej bezpečnosti a funkčnosti."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Informácie o bezpečnosti:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Naše produkty sú dodávané s podrobnými pokynmi a bezpečnostnými smernicami, ktoré je nutné prečítať a dodržiavať pred\n                              použitím.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Dôležité pokyny pre bezpečné používanie")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Používajte len originálne náhradné diely:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Dôrazne odporúčame používať iba originálne náhradné diely. Použitie neschválených dielov môže ohroziť\n                              bezpečnosť a funkčnosť zariadenia.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Nezmenšujte alebo nezneužívajte zariadenie:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Prosím, nezasahujte manuálne do zariadenia a používajte ho iba na účely, na ktoré je určené."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Odpojte zariadenie od elektrickej siete:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Ak sú potrebné údržbové práce, uistite sa, že zariadenie je úplne odpojené od elektrickej siete, aby sa\n                              predišlo elektrickým nehodám.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Postupujte podľa návodu na použitie:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Vždy dodržiavajte pokyny uvedené v návode na použitie alebo pokyny výrobcu. Odchýlky môžu viesť k poruchám\n                              alebo bezpečnostným rizikám.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Kontaktujte technickú zákaznícku podporu:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "V prípade pochybností alebo problémov so zariadením je naša technická zákaznícka podpora k dispozícii,\n                              aby vám poskytla odbornú pomoc.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Vaša zodpovednosť ako používateľa")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Dôkladne si prečítajte a pochopte všetky pokyny týkajúce sa bezpečnosti a používania."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Používajte zariadenie iba spôsobom, na ktorý je určené, a v príslušnom prostredí."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Uchovávajte zariadenie na bezpečnom mieste a mimo dosahu detí, ak nie je výslovne určené na ich používanie."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Kontaktujte našu zákaznícku podporu")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Pre podporu alebo otázky sme vám k dispozícii:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("E-mail:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Telefón:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Vaša dôvera je našou zodpovednosťou. Spoločne, s našimi produktmi a vašim bezpečným používaním, zabezpečíme, že si môžete vychutnať kvalitnú zábavu bez obáv."
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_14",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_14",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_14"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Slovenski\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_14",
                        "aria-labelledby": "heading_67921b7679be1_14",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [_vm._v("Obvestilo o varnosti izdelka")])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Vaša varnost je za nas na prvem mestu. Naši izdelki izpolnjujejo zahteve Uredbe EU o varnosti izdelkov (EU) 2023/988 in izpolnjujejo najvišje varnostne in kakovostne\n                              standarde za zagotovitev nemotenega delovanja naprav.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Naše zaveze glede varnosti izdelkov")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Upoštevanje evropskih direktiv:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Vsi naši izdelki so razviti in testirani v skladu z veljavnimi predpisi o varnosti in zdravju."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Ocena tveganja in kakovost:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Vsak izdelek prestane obsežne testne postopke, da se zagotovi največja varnost in funkcionalnost."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Informacije o varnosti:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Naši izdelki so opremljeni z podrobnimi navodili in varnostnimi smernicami, ki jih morate prebrati in upoštevati pred\n                              uporabo.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Pomembna navodila za varno uporabo")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Uporabljajte samo originalne nadomestne dele:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Opravičujemo vas, da uporabite samo originalne nadomestne dele. Uporaba nepreverjenih delov lahko\n                              vpliva na varnost in funkcionalnost naprave.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Ne spreminjajte ali zlorabljajte naprave:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Prosimo, ne spreminjajte naprave ročno in jo uporabljajte le za predvidene namene."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Odklopite iz električnega omrežja:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Če je potrebna vzdrževanje, se prepričajte, da je naprava popolnoma odklopljena od električnega omrežja, da se\n                              izognete električnim nevarnostim.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Sledite navodilom za uporabo:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Vedno sledite navodilom v priročniku za uporabnika ali navodilom proizvajalca. Odstopanja lahko povzročijo okvare\n                              ali tveganja za varnost.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Kontaktirajte tehnično podporo strankam:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "V primeru dvomov ali težav z napravo je naša tehnična podpora na voljo za strokovno pomoč."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Vaša odgovornost kot uporabnik")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Previdno preberite in razumite vsa varnostna in uporabniška navodila."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Uporabljajte napravo samo na predviden način in v primernem okolju."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Napravo shranjujte na varnem mestu in izven dosega otrok, razen če ni posebej namenjena za njihovo uporabo."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Kontaktirajte našo podporo strankam")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Za pomoč ali vprašanja smo vam vedno na voljo:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("E-pošta:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Telefon:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Vaša zaupanje je naša odgovornost. Skupaj, z našimi izdelki in vašo varno uporabo, zagotavljamo, da boste lahko uživali v visokokakovostni zabavi brez skrbi."
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_15",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_15",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_15"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Español\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_15",
                        "aria-labelledby": "heading_67921b7679be1_15",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [
                            _vm._v("Aviso de seguridad del producto")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Su seguridad es nuestra principal prioridad. Nuestros productos cumplen con los requisitos del Reglamento de Seguridad de Productos de la UE (UE) 2023/988 y cumplen con\n                              los más altos estándares de seguridad y calidad para garantizar un funcionamiento sin problemas de los dispositivos.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Nuestros compromisos con la seguridad del producto"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Cumplimiento de las directivas de la UE:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Todos nuestros productos se desarrollan y prueban de acuerdo con las normativas de seguridad y salud\n                              vigentes.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Evaluación de riesgos y calidad:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Cada producto pasa por procedimientos de prueba exhaustivos para garantizar la máxima seguridad y funcionalidad.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Información de seguridad:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Nuestros productos se entregan con instrucciones detalladas y directrices de seguridad que deben leerse y seguirse\n                              antes de su uso.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Instrucciones importantes para un uso seguro"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Utilice solo repuestos originales:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Le recomendamos encarecidamente que utilice solo repuestos originales. El uso de piezas no probadas puede\n                              afectar la seguridad y el funcionamiento del dispositivo.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("No manipule ni abuse del dispositivo:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Por favor, no modifique manualmente el dispositivo y utilícelo solo para el propósito para el cual fue\n                              diseñado.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Desconéctelo de la red eléctrica:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Si se requiere mantenimiento, asegúrese de que el dispositivo esté completamente desconectado de la red\n                              eléctrica para evitar peligros eléctricos.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Siga el manual de instrucciones:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Siempre siga las instrucciones del manual del usuario o las directrices del fabricante. Las desviaciones pueden\n                              provocar fallos o riesgos de seguridad.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Póngase en contacto con el servicio técnico de atención al cliente:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "En caso de dudas o problemas con su dispositivo, nuestro servicio técnico\n                              está disponible para brindarle apoyo profesional.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Su responsabilidad como usuario")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Lea y comprenda detenidamente todas las instrucciones de seguridad y uso."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Use el dispositivo solo de la manera prevista y en el entorno adecuado."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Guarde el dispositivo en un lugar seguro y fuera del alcance de los niños, a menos que esté específicamente diseñado para su uso."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Póngase en contacto con nuestro servicio de atención al cliente"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Para obtener soporte o realizar preguntas, estamos a su disposición:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("Correo electrónico:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Teléfono:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Su confianza es nuestra responsabilidad. Juntos, con nuestros productos y su uso seguro, nos aseguramos de que pueda disfrutar de un entretenimiento de alta calidad sin\n                              preocupaciones.\n                            "
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_16",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_16",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_16"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Magyar\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_16",
                        "aria-labelledby": "heading_67921b7679be1_16",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [_vm._v("Termékbiztonsági értesítés")])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Az Ön biztonsága számunkra az elsődleges prioritás. Termékeink megfelelnek az EU termékbiztonsági rendelet (EU) 2023/988 követelményeinek, és a legmagasabb biztonsági\n                              és minőségi előírásoknak, hogy biztosítsák a készülékek problémamentes működését.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Elkötelezettségünk a termékbiztonság iránt")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("EU irányelvek betartása:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Minden termékünket a hatályos biztonsági és egészségügyi előírásoknak megfelelően fejlesztjük és teszteljük."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Kockázatértékelés és minőség:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Minden egyes termék átfogó tesztelési eljárásokon esik át a maximális biztonság és funkcionalitás biztosítása\n                              érdekében.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Biztonsági információk:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Termékeink részletes használati utasításokkal és biztonsági előírásokkal kerülnek forgalomba, amelyeket a használat előtt\n                              el kell olvasni és be kell tartani.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Fontos útmutatások a biztonságos használathoz"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Használjon csak eredeti pótalkatrészeket:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Határozottan javasoljuk, hogy kizárólag eredeti pótalkatrészeket használjon. A nem tesztelt alkatrészek\n                              használata veszélyeztetheti a készülék biztonságát és működését.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Ne módosítsa vagy használja nem megfelelően a készüléket:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Kérjük, ne módosítsa kézzel a készüléket, és csak annak rendeltetésszerű használatra\n                              alkalmazza.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Húzza ki a készüléket az elektromos hálózatból:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Ha karbantartásra van szükség, győződjön meg arról, hogy a készülék teljesen le van választva az\n                              elektromos hálózatról, hogy elkerülje az elektromos veszélyeket.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Kövesse a használati utasítást:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Mindig kövesse a felhasználói kézikönyvben vagy a gyártó utasításaiban szereplő előírásokat. Az eltérések\n                              meghibásodásokhoz vagy biztonsági kockázatokhoz vezethetnek.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Lépjen kapcsolatba a műszaki ügyfélszolgálattal:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Kérdésekkel vagy problémákkal kapcsolatban műszaki ügyfélszolgálatunk rendelkezésére áll, hogy\n                              szakmai segítséget nyújtson.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Az Ön felelőssége, mint felhasználó")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Gondosan olvassa el és értse meg az összes biztonsági és használati utasítást."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Használja a készüléket csak annak rendeltetésszerű módon és megfelelő környezetben."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Tárolja a készüléket biztonságos helyen, és tartsa távol a gyermekektől, hacsak azt kifejezetten nem gyermekek számára tervezték."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Lépjen kapcsolatba ügyfélszolgálatunkkal")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Támogatásért vagy kérdésekért bármikor elérhet bennünket:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("E-mail:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Telefon:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Az Ön bizalma a mi felelősségünk. Közösen, termékeinkkel és az Ön biztonságos használatával biztosítjuk, hogy prémium szórakozásban élvezhesse a gondtalan pillanatokat.\n                            "
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_17",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_17",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_17"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Română\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_17",
                        "aria-labelledby": "heading_67921b7679be1_17",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [
                            _vm._v("Avertisment de siguranță a produsului")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Siguranța dumneavoastră este prioritatea noastră principală. Produsele noastre respectă cerințele Regulamentului UE privind siguranța produselor (UE) 2023/988 și\n                              îndeplinesc cele mai înalte standarde de siguranță și calitate pentru a asigura o funcționare perfectă a dispozitivelor.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Angajamentele noastre pentru siguranța produsului"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Respectarea directivelor UE:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Toate produsele noastre sunt dezvoltate și testate conform reglementărilor de siguranță și sănătate în vigoare."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Evaluarea riscurilor și calitatea:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Fiecare produs trece prin proceduri de testare extinse pentru a asigura siguranța și funcționalitatea maximă.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Informații de siguranță:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Produsele noastre sunt livrate cu instrucțiuni detaliate și ghiduri de siguranță care trebuie citite și urmate înainte\n                              de utilizare.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Instrucțiuni importante pentru utilizarea sigură"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Folosiți doar piese de schimb originale:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Recomandăm cu tărie să utilizați doar piese de schimb originale. Utilizarea pieselor necertificate poate\n                              afecta siguranța și funcționalitatea dispozitivului.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Nu modificați sau utilizați dispozitivul în mod impropriu:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Vă rugăm să nu modificați manual dispozitivul și să-l utilizați doar pentru scopul\n                              pentru care a fost destinat.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Deconectați-l de la rețeaua electrică:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Dacă este necesară întreținerea, asigurați-vă că dispozitivul este complet deconectat de la rețeaua\n                              electrică pentru a preveni pericolele electrice.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Urmați manualul de utilizare:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Urmați întotdeauna instrucțiunile din manualul utilizatorului sau ghidurile producătorului. Abaterile pot duce la\n                              defecțiuni sau riscuri de siguranță.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Contactați serviciul tehnic de asistență clienți:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "În cazul în care aveți îndoieli sau întâmpinați probleme cu dispozitivul dumneavoastră,\n                              serviciul nostru tehnic de asistență clienți este disponibil pentru a vă oferi suport profesionist.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Responsabilitatea dumneavoastră ca utilizator"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Citiți și înțelegeți cu atenție toate instrucțiunile de siguranță și utilizare."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Utilizați dispozitivul numai în scopul pentru care a fost destinat și în mediul adecvat."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Depozitați dispozitivul într-un loc sigur și ferit de copii, cu excepția cazului în care este destinat utilizării acestora."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Contactați serviciul nostru de asistență clienți"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Pentru suport sau întrebări, suntem întotdeauna la dispoziția dumneavoastră:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("Email:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Telefon:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Încrederea dumneavoastră este responsabilitatea noastră. Împreună, cu produsele noastre și utilizarea sigură a acestora, asigurăm că veți putea să vă bucurați de\n                              divertisment de înaltă calitate, fără griji.\n                            "
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_18",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_18",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_18"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Dansk\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_18",
                        "aria-labelledby": "heading_67921b7679be1_18",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [
                            _vm._v("Produkt sikkerhedsoplysninger")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Din sikkerhed er vores højeste prioritet. Vore produkter opfylder kravene i EU-forordningen om produktsikkerhed (EU) 2023/988 og opfylder de højeste sikkerheds- og\n                              kvalitetsstandarder for at sikre en problemfri enhedens drift.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Vore forpligtelser til produktsikkerhed")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Overholdelse af EU-direktiver:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Alle vores produkter er udviklet og testet i overensstemmelse med gældende sikkerheds- og sundhedsbestemmelser.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Risikovurdering og kvalitet:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Hvert produkt gennemgår omfattende testprocedurer for at sikre maksimal sikkerhed og funktionalitet."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Sikkerhedsinformation:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Vore produkter leveres med detaljerede instruktioner og sikkerhedsforskrifter, som skal læses og følges, inden de tages i\n                              brug.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Vigtige anvisninger for sikker brug")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Brug kun originale reservedele:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Vi anbefaler kraftigt at bruge kun originale reservedele. Brug af uafprøvede dele kan påvirke enhedens sikkerhed\n                              og funktionalitet.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Manipulér ikke eller misbrug ikke enheden:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Venligst ændr ikke enheden manuelt og brug den kun til det tilsigtede formål."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Frakobl enheden fra strømnettet:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Hvis vedligeholdelse er nødvendig, skal du sørge for, at enheden er helt frakoblet fra strømnettet for at undgå\n                              elektriske farer.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Følg brugsanvisningen:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Følg altid instruktionerne i brugervejledningen eller producentens anvisninger. Afvigelser kan føre til funktionsfejl\n                              eller sikkerhedsrisici.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Kontakt teknisk kundeservice:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "I tilfælde af tvivl eller problemer med din enhed er vores tekniske kundeservice til rådighed for at yde kompetent\n                              assistance.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Dit ansvar som bruger")])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Læs og forstå alle sikkerheds- og brugsanvisninger omhyggeligt."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Brug enheden kun på den måde og i det miljø, den er beregnet til."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Opbevar enheden et sikkert sted og uden for børns rækkevidde, medmindre det udtrykkeligt er beregnet til deres brug."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Kontakt vores kundeservice")])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "For support eller spørgsmål er vi altid til din rådighed:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("E-mail:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Telefon:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Din tillid er vores ansvar. Sammen, med vores produkter og din sikre brug af dem, sikrer vi, at du kan nyde kvalitetsunderholdning uden bekymringer."
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_19",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_19",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_19"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Eesti\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_19",
                        "aria-labelledby": "heading_67921b7679be1_19",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [_vm._v("Toote turvateatis")])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Teie turvalisus on meie peamine prioriteet. Meie tooted vastavad ELi tooteohutuse määruse (EL) 2023/988 nõuetele ja täidavad kõrgeima ohutuse ja kvaliteedi standardeid,\n                              tagades seadmete sujuva töö.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Meie pühendumus tooteohutusele")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("ELi direktiivide järgimine:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Kõik meie tooted on välja töötatud ja testitud vastavalt kehtivatele ohutuse ja tervise määrustele."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Riskihindamine ja kvaliteet:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Iga toode läbib ulatuslikud testimisprotseduurid maksimaalse ohutuse ja funktsionaalsuse tagamiseks."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Ohutusteave:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Meie tooted on varustatud üksikasjalike juhiste ja ohutusnõuetega, mis tuleb enne kasutamist lugeda ja järgida."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Olulised juhised ohutuks kasutamiseks")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Kasutage ainult originaalosasid:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Soovitame tungivalt kasutada ainult originaalosasid. Mittetöödeldud osade kasutamine võib mõjutada seadme\n                              ohutust ja funktsionaalsust.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Ärge muutke ega väärkasutage seadet:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Palun ärge muutke seadet käsitsi ja kasutage seda ainult ettenähtud eesmärkidel."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Lülitage seade välja toiteallikast:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Kui hooldustööd on vajalikud, veenduge, et seade oleks täielikult toiteallikast lahti ühendatud, et vältida\n                              elektrilisi ohte.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Järgige kasutusjuhendit:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Järgige alati kasutusjuhendis või tootja juhistes toodud juhiseid. Eiramine võib põhjustada rikkeid või ohutusriske.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Võtke ühendust tehnilise klienditeenindusega:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Kahtluste või probleemide korral oma seadmega on meie tehniline klienditeenindus valmis pakkuma\n                              professionaalset abi.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Teie vastutus kasutajana")])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Loe ja mõista hoolikalt kõiki ohutus- ja kasutusjuhiseid."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Kasutage seadet ainult ettenähtud viisil ja sobivas keskkonnas."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Hoidke seadet turvalises kohas ja lastele kergesti kättesaamatus kohas, välja arvatud juhul, kui see on mõeldud nende kasutamiseks."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Võtke ühendust meie klienditeenindusega")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Toetuse või küsimuste korral oleme alati teie käsutuses:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("E-post:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Telefon:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Teie usaldus on meie vastutus. Koos meie toodete ja teie ohutu kasutamisega tagame, et saate nautida kvaliteetset meelelahutust muretult."
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_20",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_20",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_20"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Česky\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_20",
                        "aria-labelledby": "heading_67921b7679be1_20",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [
                            _vm._v("Bezpečnostní upozornění na výrobek")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Vaše bezpečnost je pro nás na prvním místě. Naše produkty splňují požadavky nařízení EU o bezpečnosti výrobků (EU) 2023/988 a splňují nejvyšší bezpečnostní a\n                              kvalitativní standardy pro zajištění bezproblémového provozu zařízení.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Naše závazky k bezpečnosti výrobků")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Dodržování směrnic EU:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Všechny naše produkty jsou vyvíjeny a testovány v souladu s platnými předpisy o bezpečnosti a ochraně zdraví."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Hodnocení rizik a kvalita:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Každý produkt prochází rozsáhlými testovacími postupy, které zajišťují maximální bezpečnost a funkčnost."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Informace o bezpečnosti:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Naše produkty jsou dodávány s podrobnými pokyny a bezpečnostními předpisy, které je nutné před použitím přečíst a\n                              dodržovat.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Důležitá upozornění pro bezpečné použití")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Používejte pouze originální náhradní díly:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Důrazně doporučujeme používat pouze originální náhradní díly. Použití neověřených dílů může ovlivnit\n                              bezpečnost a funkčnost zařízení.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Nepřetvářejte ani nezneužívejte zařízení:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Prosím, neměňte zařízení ručně a používejte je pouze k zamýšlenému účelu."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Odpojte zařízení od elektrické sítě:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Pokud je nutná údržba, ujistěte se, že je zařízení úplně odpojeno od elektrické sítě, aby se vyloučily\n                              elektrické nebezpečí.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Dodržujte návod k použití:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Vždy postupujte podle pokynů v uživatelském manuálu nebo pokynů výrobce. Odchylky mohou vést k poruchám nebo\n                              bezpečnostním rizikům.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Kontaktujte technickou zákaznickou podporu:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "V případě pochybností nebo problémů s vaším zařízením je naše technická zákaznická podpora k\n                              dispozici pro odbornou pomoc.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Vaše odpovědnost jako uživatele")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Pečlivě si přečtěte a pochopte všechna bezpečnostní a provozní upozornění."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Používejte zařízení pouze způsobem a v prostředí, pro které bylo určeno."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Ukládejte zařízení na bezpečném místě, mimo dosah dětí, pokud není výslovně určeno pro jejich použití."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Kontaktujte náš zákaznický servis")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Pro podporu nebo dotazy jsme vám kdykoli k dispozici:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("E-mail:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Telefon:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Vaše důvěra je naší odpovědností. Společně, s našimi produkty a vaším bezpečným používáním, zajistíme, že si budete moci vychutnávat kvalitní zábavu bez starostí."
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_21",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_21",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_21"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Lietuvių kalba\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_21",
                        "aria-labelledby": "heading_67921b7679be1_21",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [_vm._v("Produkto saugos pranešimas")])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Jūsų saugumas mums yra svarbiausias. Mūsų produktai atitinka ES produktų saugos reglamento (ES) 2023/988 reikalavimus ir atitinka aukščiausius saugos ir kokybės\n                              standartus, užtikrinančius sklandų įrenginių veikimą.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Mūsų įsipareigojimai produkto saugai")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("ES direktyvų laikymasis:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Visi mūsų produktai yra kuriami ir testuojami pagal galiojančius saugos ir sveikatos reglamentus."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Rizikos vertinimas ir kokybė:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Kiekvienas produktas pereina išsamias bandymo procedūras, kad būtų užtikrintas maksimalus saugumas ir\n                              funkcionalumas.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Saugos informacija:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Mūsų produktai pateikiami su išsamiais naudojimo ir saugos nurodymais, kuriuos būtina perskaityti ir laikytis prieš\n                              naudojant.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Svarbios instrukcijos saugiam naudojimui")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Naudokite tik originalias atsargines dalis:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Stipriai rekomenduojame naudoti tik originalias atsargines dalis. Nepritvirtintos dalys gali paveikti\n                              įrenginio saugumą ir funkcionalumą.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Nekeiskite ir nesinaudokite įrenginiu netinkamai:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Prašome nesikeisti įrenginio rankiniu būdu ir naudoti jį tik numatytam tikslui."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Atjunkite nuo elektros tinklo:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Jei reikia atlikti priežiūrą, įsitikinkite, kad įrenginys visiškai atjungtas nuo elektros tinklo, kad išvengtumėte\n                              elektros pavojų.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Laikykitės naudojimo instrukcijos:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Visada laikykitės naudotojo vadove arba gamintojo nurodytų nurodymų. Nukrypimai gali sukelti funkcijų\n                              sutrikimus ar saugos pavojus.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Susisiekite su technine klientų aptarnavimo tarnyba:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Jei turite abejonių arba kyla problemų su įrenginiu, mūsų techninė klientų aptarnavimo\n                              tarnyba pasiruošusi suteikti profesionalią pagalbą.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Jūsų atsakomybė kaip vartotojo")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Kruopščiai perskaitykite ir supraskite visas saugos ir naudojimo instrukcijas."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Naudokite įrenginį tik numatyta tvarka ir tinkamoje aplinkoje."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Laikykite įrenginį saugioje vietoje ir toli nuo vaikų, jei jis nėra skirtas jų naudojimui."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Susisiekite su mūsų klientų aptarnavimo tarnyba"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Pagalbos arba klausimų atveju mes visada esame jums pasiekiami:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("El. paštas:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Telefonas:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Jūsų pasitikėjimas yra mūsų atsakomybė. Kartu su mūsų produktais ir jūsų saugiu naudojimu mes užtikriname, kad galėtumėte mėgautis aukštos kokybės pramogomis be\n                              rūpesčių.\n                            "
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "card-header btn btn-link text-appearance collapsed ",
                      attrs: {
                        id: "heading_67921b7679be1_22",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse_67921b7679be1_22",
                        "aria-expanded": "false",
                        "aria-controls": "collapse_67921b7679be1_22"
                      }
                    },
                    [
                      _c("h5", { staticClass: "h5 pr-5 mb-0" }, [
                        _vm._v(
                          "\n                            Croatian\n                            "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_67921b7679be1_22",
                        "aria-labelledby": "heading_67921b7679be1_22",
                        "data-parent": "#accordion_67921b7679be1"
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("p", { attrs: { id: "isPasted" } }, [
                          _c("strong", [
                            _vm._v("Sigurnosna obavijest o proizvodu")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                              Vaša sigurnost nam je na prvom mjestu. Naši proizvodi udovoljavaju zahtjevima Uredbe EU o sigurnosti proizvoda (EU) 2023/988 i ispunjavaju najviše sigurnosne i\n                              kvalitetne standarde za osiguranje nesmetanog rada uređaja.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Naše obveze za sigurnost proizvoda")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Usklađenost s EU smjernicama:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Svi naši proizvodi razvijaju se i testiraju u skladu s važećim propisima o sigurnosti i zdravlju."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Procjena rizika i kvaliteta:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Svaki proizvod prolazi kroz opsežne postupke ispitivanja kako bi se osigurala maksimalna sigurnost i funkcionalnost.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Sigurnosne informacije:")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Naši proizvodi dolaze s detaljnim uputama i sigurnosnim smjernicama koje je nužno pročitati i slijediti prije uporabe.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Važne upute za sigurno korištenje")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Koristite samo originalne rezervne dijelove:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Preporučujemo da koristite isključivo originalne rezervne dijelove. Korištenje neprovjerenih\n                              dijelova može ugroziti sigurnost i funkcionalnost uređaja.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "Nemojte mijenjati ili zloupotrebljavati uređaj:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Molimo vas da ne mijenjate uređaj ručno i da ga koristite samo u svrhe za koje je namijenjen.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Isključite uređaj iz električne mreže:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Ako je potrebna održavanje, pobrinite se da je uređaj potpuno isključen iz električne mreže kako biste\n                              izbjegli električne opasnosti.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Slijedite upute u korisničkom priručniku:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Uvijek slijedite upute u korisničkom priručniku ili uputama proizvođača. Odluke koje odstupaju mogu\n                              dovesti do nepravilnog rada ili sigurnosnih rizika.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Kontaktirajte tehničku korisničku službu:")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "U slučaju sumnje ili problema s vašim uređajem, naša tehnička korisnička služba je dostupna za stručnu\n                              pomoć.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Vaša odgovornost kao korisnika")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Pažljivo pročitajte i razumite sve sigurnosne i upute za korištenje."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Koristite uređaj samo na način i u okruženju za koje je namijenjen."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Pohranite uređaj na sigurnom mjestu i izvan dohvata djece, osim ako nije izričito namijenjen njihovoj upotrebi."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v("Kontaktirajte našu korisničku službu")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Za podršku ili upite, uvijek smo vam na raspolaganju:"
                          )
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("strong", [_vm._v("E-mail:")]),
                            _vm._v(" kundenservice@kms-handel.de")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("strong", [_vm._v("Telefon:")]),
                            _vm._v(" +49 5921 81 999 - 0")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_c("br")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Vaše povjerenje je naša odgovornost. Zajedno s našim proizvodima i vašim sigurnim korištenjem, osiguravamo da možete uživati u visokokvalitetnoj zabavi bez brige."
                          )
                        ])
                      ])
                    ]
                  )
                ])
              ]
            )
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }